import cx from 'classix';
import { AriaProgressBarProps, useProgressBar } from 'react-aria';

export const ProgressBar = (
  props: AriaProgressBarProps & {
    valueFormat?: 'percent' | 'count';
    valueLocation?: 'start' | 'end' | 'bottom' | 'none';
    rounded?: boolean;
    width?: string;
  },
) => {
  const {
    label,
    value,
    valueFormat,
    valueLocation,
    rounded,
    minValue = 0,
    maxValue = 100,
    width = '100%',
  } = props;
  const percentage = value
    ? Math.round(((value - minValue) / (maxValue - minValue)) * 100)
    : 0;
  const displayValue = valueFormat === 'count' ? `${value}/${maxValue}` : `${percentage}%`;
  const barWidth = `${Math.round(percentage)}%`;
  const ariaLabel = `Progress: ${percentage} %`

  const { progressBarProps, labelProps } = useProgressBar({ ...props, 'aria-label': ariaLabel });

  const hideValue = valueLocation === 'none';

  return (
    <div
      {...progressBarProps}
      style={{ width: width }}
      className={cx(
        'flex',
        valueLocation === 'start' && width === '100%' && 'items-start',
        (valueLocation === 'bottom' || width === '100%') && 'flex-col gap-2',
        (valueLocation === 'end' || valueLocation === 'start') &&
          width !== '100%' &&
          'items-center gap-3',
        ((valueLocation === 'end' && width === '100%') || valueLocation === 'bottom') &&
          'items-end',
      )}
    >
      {valueLocation === 'start' && width !== '100%' && !hideValue && (
        <div className='text-sm text-gray-500 font-medium w-fit'>{displayValue}</div>
      )}
      {label && (
        <div className='flex justify-between'>
          <span {...labelProps}>{label}</span>
        </div>
      )}
      <div style={{ width: '100%' }} className={cx('bg-gray-100 h-2', rounded && 'rounded-lg')}>
        <div
          style={{ width: barWidth }}
          className={cx('bg-success-500 h-2', rounded ? 'rounded-lg' : 'rounded-e-lg')}
        />
      </div>
      {(valueLocation === 'bottom' || valueLocation === 'end' || width === '100%') &&
        !hideValue && <div className='text-sm text-gray-500 font-medium w-fit'>{displayValue}</div>}
    </div>
  );
};
